import React from "react";
import { connect } from "react-redux";
import {
  Modal,
  Button,
  Spin,
  Row,
  Col,
  Upload,
  Icon,
  Form,
  Select,
  Table,
} from "antd";
import PropTypes from "prop-types";
import ImportFileImage from "../images/import-file.svg";
import ChedckedIcon from "../images/checked.svg";
import Template from "../files/people_template_v.2022.1.xls";
import ErrorImage from "../images/error-file.svg";
import { FormattedMessage, injectIntl } from "react-intl";
import "./ImportPeopleModal.scss";
import { resetFileUpload, fetchPeople } from "../store/people/actions";
import { fetchGroupPeople, fetchGroups } from "../store/groups/actions";
import Axios from "axios";
import { API_URL } from "../config/environment";
import { getCookie } from "../utils/helpers";
import { LoadingSpinner } from "./People";

const ImportPeopleModal = Form.create({
  name: "import_people_modal",
})(
  // eslint-disable-next-line
  class extends React.Component {
    static defaultProps = {
      visible: false,
    };
    static propTypes = {
      visible: PropTypes.bool,
    };
    state = { file: {}, groupId: "" };
    normFile = (e) => {
      if (Array.isArray(e)) {
        return e;
      }
      if (e.fileList.length > 1) {
        e.fileList.shift();
      }
      this.setState({ file: e.fileList[0] });
      return e && e.fileList;
    };
    handleClose = () => {
      this.setState({ file: {}, groupId: "" });
      this.props.resetFileUpload();
      this.props.handleClose();
      this.deleteTempFile();
    };
    handleOk = () => {
      if (this.props.form.getFieldValue("groupId") && !this.state.groupId) {
        this.setState({ groupId: this.props.form.getFieldValue("groupId") });
      }
      if (!this.props.peopleUploaded) {
        this.props.handleOk();
      } else if (this.props.peopleUploaded) {
        this.props.handleOk("confirm");
      }
    };
    deleteTempFile = () => {
      if (this.props.fileName) {
        Axios({
          method: "DELETE",
          url: `${API_URL}/persons/_bulk?file=${this.props.fileName}`,
          headers: {
            "content-type": "multipart/form-data",
            "x-access-token": `${getCookie("user_token")}`,
          },
        })
          .then((response) => {})
          .catch((err) => {});
      }
    };
    back = () => {
      this.setState({ file: "" });
      this.props.resetFileUpload();
      this.deleteTempFile();
    };
    beforeUpload = (file) => {
      // let fileExt = file.name.split('.');
      // fileExt = fileExt[fileExt.length - 1];
      if (file.type.startsWith("image")) {
        this.setState({ file });
        return false;
      } else {
        Modal.error({
          content: (
            <h3>
              The file that you attempted to upload ({file.name}) is not
              supported. Only excel files are accepted.
            </h3>
          ),
          okText: "Close",
        });
      }
    };
    done = () => {
      this.handleClose();
      const {
        userId,
        intl,
        siteLanguage,
        fetchPeople,
        peoplePage,
        peopleLimit,
        fetchGroupPeople,
        fetchGroups,
      } = this.props;
      if (this.state.groupId) {
        fetchGroupPeople(this.state.groupId, userId, intl, siteLanguage);
        fetchGroups(userId, intl, siteLanguage);
      } else {
        fetchPeople(userId, peopleLimit, peoplePage, intl, siteLanguage);
      }
    };
    render() {
      const {
        visible,
        groups,
        uploadedPeople,
        uploadingPeopleFromFile,
        peopleUploaded,
        uplodPeopleError,
        uploadConfirmed,
        form: { getFieldDecorator },
        fetchedGroupId,
        location,
      } = this.props;

      const { file } = this.state;
      const headers = [].concat(
        uploadedPeople &&
          uploadedPeople.length > 0 &&
          Object.keys(uploadedPeople[0]).filter(
            (person) => !person.startsWith("_")
          )
      );
      const columns = headers.map((person) => {
        return {
          title: person,
          dataIndex: `${person}`,
          key: `${person}`.toLowerCase().split(" ").join("-"),
        };
      });
      const data = []
        .concat(Array.isArray(uploadedPeople) ? uploadedPeople : [])
        .map((person, key) => {
          return {
            key: key,
            ...person,
          };
        });

      let footer = [];
      if (uploadConfirmed) {
        footer.push(
          <Button type="primary" onClick={this.done}>
            <FormattedMessage id="Done" defaultMessage="Done" />
          </Button>
        );
      } else if (peopleUploaded) {
        footer.push(
          // <Button
          //   onClick={this.handleClose}
          //   style={{ float: 'left' }}
          //   type="link"
          // >
          //   Cancel
          // </Button>,
          <Button
            style={{
              display: peopleUploaded && uplodPeopleError ? "none" : "inline",
            }}
            onClick={this.back}
          >
            <FormattedMessage id="Back" defaultMessage="Back" />
          </Button>,
          <Button
            style={{
              display:
                peopleUploaded && uplodPeopleError
                  ? "none"
                  : uploadedPeople.length <= 0
                  ? "none"
                  : "inline",
            }}
            type="primary"
            onClick={this.handleOk}
          >
            <FormattedMessage id="Continue" defaultMessage="Continue" />
          </Button>
        );
      } else {
        footer.push(
          <Button
            onClick={this.handleClose}
            style={{ float: "left" }}
            type="link"
          >
            <FormattedMessage id="Cancel" defaultMessage="Cancel" />
          </Button>,
          <Button
            style={{
              display: peopleUploaded && uplodPeopleError ? "none" : "inline",
            }}
            type="primary"
            onClick={this.handleOk}
          >
            <FormattedMessage id="Continue" defaultMessage="Continue" />
          </Button>
        );
      }

      return (
        <Modal
          destroyOnClose={true}
          className="importPeopleModal"
          maskClosable={false}
          centered
          width="1000px"
          bodyStyle={{
            minHeight: 440,
          }}
          title={
            <FormattedMessage
              id="App.ImportFromFile"
              defaultMessage={"Import from a file"}
            />
          }
          visible={visible}
          onCancel={this.handleClose}
          footer={footer}
          okText={<FormattedMessage id="Continue" defaultMessage="Continue" />}
        >
          <Spin spinning={uploadingPeopleFromFile} indicator={LoadingSpinner}>
            {!peopleUploaded && !uplodPeopleError && (
              <Row>
                <Col sm={24} md={14}>
                  <img src={ImportFileImage} alt="Import File" />
                  <h4>
                    <FormattedMessage
                      id="App.Text.HowToUpload"
                      defaultMessage={"How to upload file"}
                    />
                  </h4>
                  <div className="instructions">
                    <p>
                      1.{" "}
                      <FormattedMessage
                        id="App.Text.DownloadExcelProvided"
                        defaultMessage={"Download the excel template provided"}
                      />
                    </p>
                    <p>
                      2.{" "}
                      <FormattedMessage
                        id="App.Text.ImportPopulateExcel"
                        defaultMessage={
                          "Populate the downloaded excel spreadsheet with details of your people."
                        }
                      />
                    </p>
                    <p>
                      3.{" "}
                      <FormattedMessage
                        id="App.Text.ReturnToUpload"
                        defaultMessage={
                          "Return to this page and upload the file."
                        }
                      />
                    </p>
                  </div>
                  <p className="note">
                    <FormattedMessage
                      id="App.Text.ImportNote"
                      defaultMessage={
                        "Note: A phone number or email address is required for successfully adding a person."
                      }
                    />
                  </p>
                  <Button
                    className="downloadButton"
                    data-dfs-people-id="download-people-template-button"
                  >
                    <a download href={Template}>
                      <FormattedMessage
                        id="App.Button.DownloadTemplate"
                        defaultMessage={"Download template"}
                      />
                    </a>
                  </Button>
                </Col>
                <Col sm={24} md={10}>
                  <Form.Item>
                    {getFieldDecorator("upload", {
                      valuePropName: "fileList",
                      getValueFromEvent: this.normFile,
                      rules: [
                        {
                          required: true,
                          message: "Excel file is required",
                        },
                      ],
                    })(
                      <Upload.Dragger showUploadList={false}>
                        {file.name ? (
                          <React.Fragment>
                            {" "}
                            <p className="ant-upload-drag-icon">
                              <Icon type="file-excel" />
                            </p>
                            <h3>{file.name}</h3>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <p className="ant-upload-drag-icon">
                              <Icon type="inbox" />
                            </p>
                            <p className="ant-upload-text">
                              <FormattedMessage
                                id="App.ImportFromFile.Info1"
                                defaultMessage={"Click here to upload the file"}
                              />
                            </p>
                            <p className="ant-upload-hint">
                              <FormattedMessage
                                id="App.ImportFromFile.Info2"
                                defaultMessage={
                                  "File must be in .xls or .xlsx format"
                                }
                              />
                            </p>
                          </React.Fragment>
                        )}
                      </Upload.Dragger>
                    )}
                  </Form.Item>
                </Col>
              </Row>
            )}
            {peopleUploaded && !uplodPeopleError && !uploadConfirmed && (
              <React.Fragment>
                <h4 className="fileUploadPreviewTitle">
                  <FormattedMessage
                    id="FilePreview"
                    defaultMessage="File preview"
                  />
                </h4>
                <p className="fileUploadPreviewDescription">
                  {uploadedPeople.length <= 0 ? (
                    <React.Fragment>
                      <FormattedMessage
                        id="App.ImportFromFile.Info4"
                        defaultMessage="There is no data in this file."
                      />
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <FormattedMessage
                        id="App.ImportFromFile.Info3"
                        defaultMessage="Here's some sample data from your file, click continue to proceed"
                      />
                    </React.Fragment>
                  )}
                </p>
                <Table
                  scroll={{ x: "max-content" }}
                  bordered
                  columns={columns}
                  dataSource={data}
                  size={"small"}
                  pagination={false}
                />
                <p className="fileUploadPreviewAddGroup">
                  <FormattedMessage
                    id="AddPeopleTo"
                    defaultMessage="Add these people to"
                  />
                  :
                </p>
                <Form.Item colon={false}>
                  {getFieldDecorator("groupId", {
                    initialValue: `${
                      location ? location.pathname : ""
                    }`.includes("/groups/")
                      ? fetchedGroupId || ""
                      : "",
                  })(
                    <Select
                      onChange={(e) => {
                        this.setState({ groupId: e });
                      }}
                      style={{ width: 200 }}
                    >
                      <Select.Option key="everyone" value="">
                        <FormattedMessage
                          id="Everyone"
                          defaultMessage="Everyone"
                        />
                      </Select.Option>
                      {groups.map((opt) => (
                        <Select.Option key={opt.uuid} value={opt.uuid}>
                          {opt.name}
                        </Select.Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </React.Fragment>
            )}
            {peopleUploaded && uplodPeopleError && (
              <div
                style={{
                  textAlign: "center",
                  marginTop: "7%",
                }}
              >
                <img
                  src={ErrorImage}
                  alt="Error"
                  style={{ marginBottom: "1rem" }}
                />
                <p style={{ color: "#CD1717", fontSize: "0.8rem" }}>
                  <FormattedMessage
                    id="App.ImportFromFile.Failed1"
                    defaultMessage="Sorry, We could not import your file."
                  />
                </p>
                <p style={{ color: "#707070", fontSize: "0.8rem" }}>
                  Use the template provided below and follow instructions on how
                  to insert your data and
                  <br /> try importing again. Make sure Email or Phone Number is
                  defined for each person.
                </p>
                <div>
                  <Button className="downloadButton">
                    <a download href={Template} style={{ fontSize: "0.8rem" }}>
                      <FormattedMessage
                        id="App.Button.DownloadTemplate"
                        defaultMessage={"Download template"}
                      />
                    </a>
                  </Button>
                </div>
                <div>
                  <Button
                    style={{ color: "#05538C", fontSize: "0.8rem" }}
                    type="link"
                    onClick={this.back}
                  >
                    <FormattedMessage
                      id="App.Text.TryImport"
                      defaultMessage={"Try import again"}
                    />
                  </Button>
                </div>
              </div>
            )}
            {peopleUploaded && !uplodPeopleError && uploadConfirmed && (
              <React.Fragment>
                <div style={{ textAlign: "center", marginTop: "15%" }}>
                  <img
                    src={ChedckedIcon}
                    alt="CheckedIcon"
                    style={{ display: "inline-block" }}
                  />
                  <span
                    style={{
                      color: "#0B7D1A",
                      display: "inline-block",
                      paddingLeft: 10,
                      textAlign: "left",
                    }}
                  >
                    <FormattedMessage
                      id="App.ImportFromFile.Success"
                      defaultMessage="Your file has been imported successfully!"
                    />
                  </span>
                </div>
              </React.Fragment>
            )}
          </Spin>
        </Modal>
      );
    }
  }
);
const mapStateToProps = (state) => ({
  siteLanguage: state.intl.siteLanguage,
  userId: state.user.userId,
  groups: state.groups.groups,
  uploadConfirmed: state.people.uploadConfirmed,
  peoplePage: state.people.peoplePage,
  peopleLimit: state.people.peopleLimit,
  uploadingPeopleFromFile: state.people.uploadingPeopleFromFile,
  fileName: state.people.fileName,
});

const mapDispatchToProps = (dispatch) => ({
  resetFileUpload: () => {
    dispatch(resetFileUpload());
  },
  fetchPeople: (userId, limit, page, intl, siteLanguage) => {
    dispatch(fetchPeople(userId, limit, page, intl, siteLanguage));
  },
  fetchGroupPeople: (groupsId, userId, intl, siteLanguage) => {
    dispatch(fetchGroupPeople(groupsId, userId, intl, siteLanguage));
  },
  fetchGroups: (userId, intl, siteLanguage) => {
    dispatch(fetchGroups(userId, intl, siteLanguage));
  },
});
const WrappedImportPeopleModal = Form.create()(ImportPeopleModal);

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(WrappedImportPeopleModal)
);
